import { useEffect } from "react";

type SanctuaryEntryScreenProps = {
  onEnter: () => void;
  onSuccess: () => void;
};

export default function SanctuaryEntryScreen({
  onEnter,
 // onSuccess,
}: SanctuaryEntryScreenProps) {

  return (
    <main className="entry-container">
      <header className="entry-header">
        <div className="entry-brand">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo-small"
          />

          <div>
            <div className="entry-brand-name">Calm But Capable</div>
            <div className="entry-brand-subtitle">The Sanctuary</div>
          </div>
        </div>

        <button className="entry-login-button" onClick={onEnter}>
          Login
        </button>
      </header>

      <section className="entry-card">
        <div className="entry-logo-wrap">
          <img
            src="/logo-white.png"
            alt="Calm But Capable"
            className="entry-logo"
          />
        </div>

        <p className="entry-eyebrow">Calm But Capable presents</p>

        <h1 className="entry-title">The Sanctuary</h1>

        <p className="entry-tagline">
          Regain clarity and move forward one step at a time.
        </p>

       <p className="entry-subtitle">
        The Sanctuary is designed for capable people who feel stuck,
        mentally overloaded, or unsure where to begin. Learn practical
        systems to reduce mental clutter, regain focus, and create
        sustainable forward movement.
       </p>

        <p className="entry-workshop">
          Includes access to a free workshop designed to help you take the next step and move forward more clearly.
        </p>

          <div className="entry-form">
        <a
          className="entry-button entry-button-link"
          href="https://calm-but-capable.kit.com/3e9b23e333"
        >
          Get the Free Workshop
        </a>
      </div>
            
       <p className="entry-small-print">
        After signing up, please check your inbox, spam, junk, or promotions folder.
        Some secure email providers may block confirmation emails.
      </p>
      </section>

      <p className="entry-transition">
        Modern life creates constant mental noise. The Sanctuary is designed
        to help you slow things down, regain clarity, and move forward more calmly.
      </p>
     <div className="entry-content">
     <section className="entry-section">
     <h2 className="entry-section-title">Who The Sanctuary Is For</h2>
    
      <div className="entry-feature-list">
    <div className="entry-feature">
      You feel capable, but life often feels mentally cluttered.
    </div>

    <div className="entry-feature">
      You struggle knowing where to begin, even with important tasks.
    </div>

    <div className="entry-feature">
      You juggle too many responsibilities and constantly switch focus.
    </div>

    <div className="entry-feature">
      You often know what you want to do, but struggle to maintain momentum consistently.
    </div>

    <div className="entry-feature">
      You want sustainable progress without constant pressure and burnout.
    </div>
  </div>
</section>

<section className="entry-section">
  <h2 className="entry-section-title">How It Works</h2>

  <div className="entry-steps">
    <div className="entry-step">
      <span className="entry-step-number">1</span>
      Reduce mental clutter and create clarity.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">2</span>
      Identify one clear next step instead of carrying everything at once.
    </div>

    <div className="entry-step">
      <span className="entry-step-number">3</span>
      Build calm, sustainable forward movement over time.
    </div>
  </div>

  <div className="entry-form">
    <a
      className="entry-button entry-button-link"
      href="https://calm-but-capable.kit.com/3e9b23e333"
    >
      Get the Free Workshop
    </a>
  </div>
</section>
</div>
    </main>
  );
}